import { render, staticRenderFns } from "./pref.vue?vue&type=template&id=ec470f1c&lang=pug&"
import script from "./pref.vue?vue&type=script&lang=js&"
export * from "./pref.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports